import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import locationsSelector from "../selectors/locationsSelector";
import Search from "../components/Search";
import { updateKeyword } from "../actions/filter";
import { updateLocationState } from "../actions/map";

class SearchContainer extends Component {
  render() {
    const { keyword, locations } = this.props;

    return (
      <Search
        keyword={keyword}
        locations={locations}
        updateLocationState={this.props.updateLocationState}
        updateKeyword={this.props.updateKeyword}
      />
    );
  }
}

SearchContainer.propTypes = {
  locations: PropTypes.array.isRequired,
  updateKeyword: PropTypes.func.isRequired,
  updateLocationState: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const locations = locationsSelector(state) || [];
  return {
    keyword: state.filterReducer.keyword,
    locations,
  };
}

export default connect(mapStateToProps, { updateKeyword, updateLocationState })(
  SearchContainer
);
